module.exports = __webpack_public_path__ + "static/media/moo.474ab13b.png";